import { defineComponent as _defineComponent } from 'vue'
import { ButtonBoxLaunch, Heading } from '@warrenbrasil/nebraska-web';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { AccountStatus } from '@/modules/trade/services/account';

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

interface Props {
  tradeStatus?: AccountStatus;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ServicesSection',
  props: {
    tradeStatus: null
  },
  setup(__props: any) {

const props = __props as {
  tradeStatus?: AccountStatus;
}



const router = useRouter();

const shouldShowProfit = computed(() =>
  FeatureFlagsModule.isEnabled(FeatureFlags.ENABLE_PROFIT_VIEW)
);

const shouldShowRLP = computed(() =>
  FeatureFlagsModule.isEnabled(FeatureFlags.SHOW_RLP_PAGE)
);

const shouldShowMarginAllocation = computed(() =>
  FeatureFlagsModule.isEnabled(FeatureFlags.ENABLE_MARGIN_ALLOCATION)
);

const services = ref<any>([
  {
    enabled: shouldShowMarginAllocation,
    label: 'Limites Day Trade',
    icon: 'EE0160',
    route: 'marginAllocation',
    chipLabel: 'Novo'
  },
  {
    enabled: shouldShowProfit,
    label: 'Plataformas de negociação',
    icon: 'CB0030',
    route: 'profitSubscription',
    chipLabel: 'Novo'
  },
  {
    enabled: shouldShowRLP,
    label: 'Warren RLP',
    icon: 'BB0040',
    route: 'retailLiquidityProvider',
    chipLabel: props.tradeStatus?.isRLPEnabled ? 'Ativo' : null,
    chipStyle: 'success'
  },
  {
    enabled: false,
    label: 'Calculadora de IR',
    icon: 'EF0040',
    route: 'incomeTaxCalculator'
  },
  {
    enabled: false,
    label: 'Custódia remunerada',
    icon: 'BB0030',
    route: ''
  },
  {
    enabled: false,
    label: 'TradeMap',
    icon: 'EE0110',
    route: ''
  }
]);

const hasSomeButtonToShow = computed(() =>
  services.value.some((button: any) => button.enabled)
);

function getChipCustomStyle(chipStyle: string | undefined) {
  if (!chipStyle) return;
  return `services-section__chip--${chipStyle}`;
}
function pushRoute(route: string) {
  router.push({ name: route });
}

return { __sfc: true,props, router, shouldShowProfit, shouldShowRLP, shouldShowMarginAllocation, services, hasSomeButtonToShow, getChipCustomStyle, pushRoute, ButtonBoxLaunch, Heading }
}

})